@if (!isOpen) {
  <div
    #draggableBox
    class="fixed right-20 bottom-0 z-50 flex cursor-move justify-center gap-2 rounded-2xl bg-white p-4 shadow-lg"
    (mousedown)="startDrag($event)">
    <span class="material-symbols-rounded"> preview </span> Vorschau
    <span
      class="material-symbols-rounded cursor-pointer text-gray-400"
      (click)="openPreview()">
      open_in_full
    </span>
  </div>
} @else if (isOpen && !isMax) {
  <div
    #draggableBox
    class="fixed right-20 bottom-0 z-50 flex h-[34rem] w-lg flex-col gap-2 rounded-2xl bg-white p-4 shadow-lg">
    <div class="flex h-6 w-full items-center justify-between">
      <span class="material-symbols-rounded"> preview </span>
      <span
        class="material-symbols-rounded rotate-90 cursor-move text-gray-400"
        #dragHandle
        (mousedown)="startDrag($event)">
        drag_indicator
      </span>
      <div class="flex gap-2">
        <span
          class="material-symbols-rounded cursor-pointer text-gray-400"
          (click)="maxPreview()">
          open_in_full
        </span>
        <span
          class="material-symbols-rounded cursor-pointer text-gray-400"
          (click)="closePreview()">
          close
        </span>
      </div>
    </div>
    <div class="flex h-112 w-full rounded bg-[#EEE]">
      <aw-preview-content
        [previewData]="previewData()"
        [isMobile]="isMobile"
        class="w-full"
        [components]="components()" />
    </div>
    <div class="flex h-6 w-full items-center justify-end gap-4">
      <aw-dark-mode-toggle class="flex h-6 items-center"></aw-dark-mode-toggle>
      <span
        class="material-symbols-rounded cursor-pointer"
        (click)="toggleScreenSize()">
        {{ isMobile ? 'desktop_windows' : 'phone_android' }}
      </span>
    </div>
  </div>
} @else if (isOpen && isMax) {
  <div
    [ngStyle]="{
      left: maxViewOffset,
    }"
    class="fixed inset-0 z-50 flex flex-col gap-2 rounded-none bg-white p-4 shadow-lg">
    <div class="flex h-6 w-full items-center justify-between">
      <span class="material-symbols-rounded"> preview </span>
      <div class="flex gap-2">
        <span
          class="material-symbols-rounded cursor-pointer text-gray-400"
          (click)="minPreview()">
          close_fullscreen
        </span>
        <span
          class="material-symbols-rounded cursor-pointer text-gray-400"
          (click)="closePreview()">
          close
        </span>
      </div>
    </div>
    <div class="flex h-[calc(100vh-8rem)] w-full rounded bg-[#EEE]">
      <aw-preview-content
        [previewData]="previewData()"
        [isMobile]="isMobile"
        class="w-full"
        [components]="components()" />
    </div>
    <div class="flex h-6 w-full items-center justify-end gap-4">
      <aw-dark-mode-toggle class="h-6"></aw-dark-mode-toggle>
      <span
        class="material-symbols-rounded cursor-pointer"
        (click)="toggleScreenSize()">
        {{ isMobile ? 'phone_android' : 'desktop_windows' }}
      </span>
    </div>
  </div>
}
